import { render } from "./FooterLogo.vue?vue&type=template&id=9df7b3cc"
import script from "./FooterLogo.vue?vue&type=script&lang=js"
export * from "./FooterLogo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__